import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { Enumroles } from '@app/models/enumroles.enum';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { Sign } from '@app/models/sign';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { Router } from '@angular/router';
import { ClaimsService } from '@app/services/claims/claims.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MemberShort } from '@app/models/member';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { ConfirmDialogModel, ConfirmdialogComponent } from '@app/components/shared/dialog/confirmdialog/confirmdialog.component';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface Office {
  memberId: number;
  institutionId: number;
  officeCommitteeId: number;
  action: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  selector: 'app-addoffice-test',
  templateUrl: './addoffice.component.html'
})

export class AddofficeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() memberid: number;
  @Input() baseinfo: any;
  @Input() admininstitutions: number[];
  @Output() valueChange = new EventEmitter();
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  institutionlist: LodgeAndCamp[] = [];

  signsSubscription: Subscription;
  signs: Sign[] = [];
  institution: string;
  offices: Office[] = [];
  members: MemberShort[] = [];
  selectedSignsForm: FormGroup;
  selectedmembers: MemberShort[] = [];
 form;
  

  /* start autocomplete */
  myControl = new FormControl();
  items: FormArray;
  data: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  /* end autocomplete */

  isClerk = false;
  isSysAdmin = false;

  subscriptions: Subscription[] = [];

  // tslint:disable-next-line:max-line-length
  constructor(private fb: FormBuilder, private snackbarService: SnackbarService, private dialog: MatDialog, private institutionsService: InstitutionsService, private router: Router, private claimsService: ClaimsService, private memberOfficeService: MemberofficeService) { }

  ngOnInit() {

    this.form = this.fb.group({
      institutionId: ['', Validators.required],
      officeCommitteeId: ['', Validators.required],
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });
    
    if (this.claimsService.isClerk() || this.claimsService.isSysAdmin()) {
      this.isClerk = this.claimsService.isClerk();
      this.isSysAdmin = this.claimsService.isSysAdmin();
      this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
        data.forEach(element => {
          const inst = { id: element.id, shortName: element.shortName, name: element.name };
          this.data.push(inst);
        });

        /* start autocomplete */
        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith<string | LodgeAndCamp>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.data.slice())
          );
        /* end autocomplete */
      }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.admininstitutions) {
      this.admininstitutions = changes.admininstitutions.currentValue;
      this.listClaims();
    }
  }

  getPossibleOffices(institutionId: number) {
    if (institutionId === 0) {
      this.offices = [];
    } else {
      this.subscriptions.push(this.memberOfficeService.GetPossibleOffices(institutionId).subscribe(data => {
        this.offices = data;
      }));
    }
  }

  getPossibleOfficesEvent(event: any) {
    const institutionId = event.target.value;
    if (institutionId === 0) {
      this.offices = [];
    } else {
      this.subscriptions.push(this.memberOfficeService.GetPossibleOffices(institutionId).subscribe(data => {
        this.offices = data;
      }));
    }
  }

  setInstitution(institutionId: number) {
    const idx = this.institutionlist.findIndex(item =>
      item.id === institutionId);
    // tslint:disable-next-line:max-line-length
    idx !== -1 ? this.institution = ' i ' + this.institutionlist[idx].shortName + ' ' + this.institutionlist[idx].name : this.institution = '';
  }

  listClaims() {
    this.institutionlist = [];
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.ADMIN_LODGE || element.key === Enumroles.ADMIN_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });

    const tempinstitutionlist = [];
    this.institutionlist.forEach(i => {
      if (this.admininstitutions.indexOf(i.id) !== - 1) {
        tempinstitutionlist.push(i);
      }
    });
    this.institutionlist = tempinstitutionlist;
  }

  getOfficesByInstitutionId(institutionid: number) {
    this.offices = [];
    this.getPossibleOffices(institutionid);
    if (this.members.length > 0) {
      this.members = [];
    }
  }

  saveOffice() {
    this.offices = [];
    const office = {
      memberId: Number(this.memberid),
      institutionId: this.form.get('institutionId').value,
      officeCommitteeId: Number(this.form.get('officeCommitteeId').value),
      action: 'add',
      fromDate: this.form.get('fromDate').value,
      toDate: this.form.get('toDate').value
    };

    this.offices.push(office as any);

    this.subscriptions.push(this.memberOfficeService.UpdateMemberOffice(this.offices).subscribe(response => {
      if (response) {
        if (response[0].status === 'ok') {
          this.valueChange.emit('officeAdded');
          this.router.navigate(['/memberform/id/', this.memberid]);
          this.snackbarService.openSnackBar('Uppdraget tillagt', null);
        } else {
          const message = response[0].status;
          const dialogData = new ConfirmDialogModel('', message, 'info', false);
          const dialogRef = this.dialog.open(ConfirmdialogComponent, {
            minWidth: '400px',
            minHeight: '200px',
            data: dialogData
          });

          dialogRef.afterClosed().subscribe(dialogResult => {
          });
        }
      }
    }));
  }

  cancel() {
    this.valueChange.emit('cancelAddOffice');
    this.router.navigate(['/memberform/id/', this.memberid]);
  }

  /* start autocomplete */
  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.data.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  displayFn(user?: LodgeAndCamp): string | undefined {
    return user ? user.shortName + ' ' + user.name : undefined;
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.clearSelectedSignsForm();
    this.selectedinstitution = event.option.value.id;
    this.form.get('institutionId').setValue(event.option.value.id);
    this.getOfficesByInstitutionId(event.option.value.id);
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
  }

  clearSelectedSignsForm() {
    if (this.selectedSignsForm) {
      const controllength = this.selectedSignsForm.controls.items.value.length;
      for (const c of this.selectedSignsForm.controls.items.value) {
        this.removeFromArray(c.memberId);
      }
    }
  }

  removeSelectedMember(id: number) {
    const elementidx = this.selectedmembers.findIndex(obj => obj.id === id);
    this.selectedmembers.splice(elementidx, 1);
  }

  removeFromArray(id: number) {
    const idx = this.members.findIndex(item => item.id === id);
    this.members[idx].checked = false;
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === id));
    this.removeSelectedMember(id);
  }

  clear() {
    this.myControl.setValue(null);
  }
}
